import { DUMMY_REMINDERS } from '../../constants/dummy';
import { sentReminderTableColumns } from '../../constants/tableColumns';
import AcademiaTable from '../CommonComps/Tables/AcademiaTable';
import PageHeader from '../CommonComps/Titles/PageHeader';
import CreateReminderAction from './CreateReminderAction';

const ShowAllSentReminders = () => {
  // rendering show all sent remainder section component here
  return (
    <section>
      <PageHeader headerText='All Reminders' />

      <AcademiaTable
        data={DUMMY_REMINDERS}
        columns={sentReminderTableColumns}
        tableToolbarComponent={<CreateReminderAction />}
        notFoundMessage='No reminder found!'
      />
    </section>
  );
};

export default ShowAllSentReminders;
